// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"bf675605","171":"bf675605","403":"2e4e3e0f","774":"bf675605","918":"bf675605"}[chunkId] + ".chunk.css";
};